import React, { useEffect } from "react";
import TimeIcon from "assets/svgIcons/TimeIcon";
import TodayCalIcon from "assets/svgIcons/AdminDashboard/TodayCalIcon";
import YesterdayCalIcon from "assets/svgIcons/AdminDashboard/YesterdayCalIcon";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useHookstate } from "@hookstate/core";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";

const RoundsCompleted = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const {
    getRoundsCompletedState,
    siteSettingsData,
    getDashboardFeatureSetStatus,
  } = useSelector((state) => state?.commonReducers) || {};
  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      const theCurrQueryDate = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DD");

      dispatch(
        COMMON_SERVICES.getRoundsCompletedServices(
          siteId.get(),
          theCurrQueryDate,
          localStorage.getItem("dashCourseId")
        )
      );
    }
  }, [
    getDashboardFeatureSetStatus,
    localStorage.getItem("dashCourseId"),
    siteId.get(),
    siteSettingsData,
  ]);

  return (
    <>
      <div className="header">
        <TimeIcon color="#000" width={25} height={20} />
        <p>{t("Rounds_Completed")}</p>
      </div>
      <div className="box-body day-box-body ">
        <div className="day-div">
          <TodayCalIcon />
          <span className="round">
            {getRoundsCompletedState && getRoundsCompletedState?.CurrDay}
          </span>
          <p className="bp-sub-heading">{t("Today")}</p>
        </div>
        <div className="day-div">
          <YesterdayCalIcon />
          <span className="round">
            {getRoundsCompletedState && getRoundsCompletedState?.LastDay}
          </span>
          <p className="bp-sub-heading">{t("Yesterday")}</p>
        </div>
      </div>
    </>
  );
};

export default RoundsCompleted;
